import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import useWindowDimensions from "../../utils/useWindowDimensions";

const HorizontalBarChart = ({ data = [], xKey = "name", yKey = "count", chartName = "Findings", compact = false }) => {
  const { width } = useWindowDimensions();
  const [chartData, setChartData] = useState({ series: [], options: {} });
  const height = compact ? 220 : width > 1700 ? 300 : 250;

  useEffect(() => {
    setChartData({
      series: [
        {
          name: chartName,
          data: data.map((item) => item[yKey] ?? 0),
        },
      ],
      options: {
        chart: {
          type: "bar",
          height,
          toolbar: { show: false },
        },
        colors: ["#e11d48"],
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 3,
            barHeight: "60%",
          },
        },
        dataLabels: { enabled: false },
        xaxis: {
          categories: data.map((item) => item[xKey] ?? "N/A"),
          labels: { style: { fontSize: "11px" } },
        },
        yaxis: {
          labels: { style: { fontSize: "11px" } },
        },
        grid: { borderColor: "#f0f1f3" },
        tooltip: {
          y: { formatter: (val) => val },
        },
      },
    });
  }, [data, xKey, yKey, chartName, height]);

  if (!data?.length) {
    return null;
  }

  return <ReactApexChart options={chartData.options} series={chartData.series} type="bar" height={height} />;
};

export default HorizontalBarChart;
